/* generated by pull.js */
const manifest = {
  "editorOnly": true,
  "noTranslations": true,
  "name": "Customizable new sprite position",
  "description": "Change where newly created sprites are placed on the stage.",
  "credits": [
    {
      "name": "pufferfish101007",
      "link": "https://scratch.mit.edu/users/pufferfish101007/"
    }
  ],
  "dynamicDisable": true,
  "userscripts": [
    {
      "url": "userscript.js"
    }
  ],
  "settings": [
    {
      "dynamic": true,
      "id": "x",
      "name": "X position",
      "type": "integer",
      "default": 0,
      "min": -240,
      "max": 240
    },
    {
      "dynamic": true,
      "id": "y",
      "name": "Y position",
      "type": "integer",
      "default": 0,
      "min": -180,
      "max": 180
    },
    {
      "dynamic": true,
      "id": "library",
      "name": "Place sprites from library at random position",
      "type": "boolean",
      "default": false
    },
    {
      "dynamic": true,
      "id": "duplicate",
      "name": "Position for duplicated sprites",
      "type": "select",
      "default": "randomize",
      "potentialValues": [
        {
          "id": "custom",
          "name": "Specified x/y position"
        },
        {
          "id": "keep",
          "name": "Same as original sprite"
        },
        {
          "id": "randomize",
          "name": "Random"
        }
      ]
    }
  ],
  "tags": [],
  "enabledByDefault": false
};
export default manifest;
